import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import HomeView from '@/views/Home/HomeView.vue';
import { store } from '@/store';
import types from '@/store/types';

declare module 'vue-router' {
  interface RouteMeta {
    title?: string;
  }
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: '组队赚KK币',
    },
  },
  {
    path: '/record-list',
    name: 'recordList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "record-list" */ '../views/RecordListView.vue'
      ),
    meta: {
      title: 'KK币赚取记录',
    },
  },
  {
    path: '/record-detail',
    name: 'recordDetail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "record-detail" */ '../views/RecordDetailView.vue'
      ),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.afterEach(function (to) {
  if (typeof to.meta.title === 'string') {
    store.commit(types.SET_TITLE, to.meta.title);
  }
});

export default router;
